import { Box, MenuItem, Select, Table, TableBody, TableContainer, TableHead } from "@mui/material";
import LabelHeader from "components/Label/LabelHeader";
import TableRowComponent, { DataHeaderType } from "components/table/TableRowComponent";
import { isPriceLabel } from "utils";
import { EstCreateRequest } from "../types";

interface Props {
  headerData: DataHeaderType[];
  rowData: DataHeaderType[];
  disableRounding?: boolean;
  setEstResultByKey?: (key: keyof EstCreateRequest, value: any) => void;
  estResult?: EstCreateRequest;
}

/**
 * TableEstDiscount component renders a table with a label and optional sx prop for styling.
 * @param {Object} props - The properties object.
 */
export default function TableEstDiscount({
  headerData,
  rowData,
  disableRounding,
  estResult,
  setEstResultByKey,
}: Props) {
  // Wrap price labels with ¥ and value, space-between layout
  const transformedRowData = rowData.map((item) => ({
    ...item,
    label: isPriceLabel(item.label) ? (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Box component="span">¥</Box>
        <Box component="p" sx={{ textAlign: "center", width: "100%", my: 0 }}>{item.label}</Box>
      </Box>
    ) : (
      item.label
    ),
  }));

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        minWidth: 1200,
        minHeight: 100,
      }}
    >
      <TableContainer component={Table} sx={{ boxShadow: "none", width: "auto" }}>
        <TableHead>
          <TableRowComponent data={headerData} type="header" />
        </TableHead>
        <TableBody>
          <TableRowComponent data={transformedRowData} />
        </TableBody>
      </TableContainer>
      {!disableRounding && (
        <Box sx={{ width: 142, gap: "2px" }}>
          <LabelHeader
            label="丸め"
            sxTypography={{
              boxSizing: "border-box",
              ml: 0,
              justifyContent: "center",
            }}
            sxBox={{
              height: { xs: 48, md: 46 },
              boxSizing: "border-box",
              justifyContent: "center",
              width: "100%",
              backgroundColor: "var(--offwhite-500)",
            }}
          />
          <Select
            value={estResult?.round_type || "0"}
            onChange={(event) => {
              if (setEstResultByKey) {
                setEstResultByKey("round_type", event.target.value);
              }
            }}
            size="medium"
            sx={{
              boxSizing: "border-box",
              height: "49px",
              width: "141px",
              border: "none",
              borderRadius: "0px",
              fontSize: { xs: "16px", md: "18px", xl: "20px" },
              "& .MuiInputBase-input": {
                p: "11.5px 14px",
                textAlign: "center",
              },
            }}
          >
            {Object.keys(Array.from({ length: 4 })).map((value) => (
              <MenuItem value={String(value)} key={String(value)}>
                {String(value)}
              </MenuItem>
            ))}
          </Select>
        </Box>
      )}
    </Box>
  );
}
